export default "window._mfq = window._mfq || [];\n"